// src/sections/jobFest/JobFestCards.tsx
import React from "react";
import BuildingsImg from "../../assets/jobfest/buildings.png";
import ProfessionalImg from "../../assets/jobfest/professional.png";

export const JobFestCards: React.FC = () => {
  return (
    <section className="cards-section jobfest-cards">
      <div className="section-header">
        <p className="section-kicker section-kicker--wave">
          <span className="section-wave" />
          <span className="section-code-pill">
            <span className="section-code-pill-prefix"></span>
            Two pathways. One AI hiring sprint.
          </span>
        </p>
        <h2 className="section-title">
          For companies and candidates to meet in one curated AI talent pool.
        </h2>
      </div>

      <div className="card-wrapper">
        <div className="card-row">
          {/* EMPLOYER CARD */}
          <article
            className="card card--employer"
            data-label="COMPANIES"
            id="employer-card"
          >
            <div className="card-avatar card-avatar--employer">
              <img
                src={BuildingsImg}
                alt="City skyline representing companies"
                className="card-avatar-img"
              />
            </div>

            <div className="card-left">
              <div className="tag">
                <span className="dot" />
                For companies · Babblebots Job Fest
              </div>

              <h3 className="title">
                Inviting companies: priority access to India’s top 5% AI talent
              </h3>

              <p className="subtitle">
                Join our December AI Talent Fest and hire AI Engineers &amp; AI
                Interns from a curated pan-India pool.
              </p>

              <div className="roles">
                <div className="roles-label">Talent available</div>
                <ul className="list">
                  <li>AI Engineer</li>
                  <li>AI Intern</li>
                </ul>
              </div>

              <div className="meta-row">
                <div>
                  <span className="meta-label">Registration window:</span>{" "}
                  8–12 Dec 2025
                </div>
                <div>
                  <span className="meta-label">Seats:</span> Only 10 companies
                </div>
              </div>

              <div className="meta-row meta-row--muted">
                <div>
                  <span className="meta-label">AI Interview Fest:</span> 13–16
                  Dec 2025
                </div>
                <div>
                  <span className="meta-label">Offer round:</span> 17–19 Dec
                  2025
                </div>
              </div>

              <div className="trust">
                <span className="badge">Trusted results</span>
                Backed by Indus Towers, TIH, Bharat Gen, Ajmera, Valuefy, Qubit Capitaly & Growisto – 250+ companies &amp; 2000+ roles.
              </div>

              <div className="card-actions">
                <a
  className="cta-btn"
  href="https://calendly.com/sales-babblebots/babblebots-discovery"
  target="_blank"
  rel="noopener noreferrer"
>
  Book demo &amp; reserve seat
  <span className="arrow">↗</span>
</a>

                <p className="help-text">
                  Lock your company’s slot &amp; share AI hiring needs.
                </p>
              </div>
            </div>
          </article>

          {/* CANDIDATE CARD */}
          <article
            className="card card--candidate"
            data-label="CANDIDATES"
            id="candidate-card"
          >
            <div className="card-avatar card-avatar--candidate">
              <img
                src={ProfessionalImg}
                alt="Young professional candidate"
                className="card-avatar-img"
              />
            </div>

            <div className="card-left">
              <div className="tag">
                <span className="dot" />
                For candidates · Babblebots Job Fest
              </div>

              <h3 className="title">We’re hiring for 30 AI roles</h3>

              <div className="candidate-ribbon">
                Across 10 companies using Babblebots AI Interview as the first
                round.
              </div>

              <div className="roles">
                <div className="roles-label">Open positions</div>
                <ul className="list">
                  <li>AI Engineer</li>
                  <li>AI Intern</li>
                </ul>
              </div>

              <div className="meta-row">
                <div>
                  <span className="meta-label">Job type:</span> Remote · Hybrid
                  · On-site
                </div>
                <div>
                  <span className="meta-label">Experience:</span> 0–4 years
                </div>
              </div>

              <div className="meta-row meta-row--muted">
                <div>
                  <span className="meta-label">AI interview round:</span> 13–16
                  Dec 2025
                </div>
              </div>

              <div className="trust">
                <span className="badge">Proof of scale</span>
                Powered by Babblebots AI –{" "}
                <strong>2,00,000+ candidates screened</strong> across India.
              </div>

              <div className="card-actions">
                <a
  className="cta-btn"
  href="https://forms.gle/VYe6GSe7ocNnsRmJ6"
  target="_blank"
  rel="noopener noreferrer"
>
  Apply now – take AI interview
  <span className="arrow">⟶</span>
</a>
                <p className="help-text">
                  Upload your CV &amp; complete round one on{" "}
                  <span>babblebots.ai</span>.
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};
